export default __webpack_public_path__ + "static/media/vjcscancode.3289e0d7.jpg";